<template>
  <div class="TopicOptions">
    <h4>Topics</h4>
    <!-- <ul>
      <li v-for="(filter,index) in FullTopicFilters" :key="'edtoolfilter' + index"><CheckInput :key="'checkInput-'+'edtoolsfilter-' + index" :item="filter" /></li>
    </ul> -->
    <!-- <h4>Media Literacy and First Amendment Skillsets</h4> -->
    <ul>
      <li v-for="(filter,index) in FullTopicFilters" :key="'otherlearningfilter' + index"><CheckInput :key="'topic-options-check-' + index" :item="filter" /></li>
    </ul>
  </div>
</template>

<script>
var TopicFilters = window.drupalSettings ? window.drupalSettings.searchFilters.topic : null
import CheckInput from '@/components/CheckInput'

export default {
  name: 'TopicOptions',
  components: { CheckInput },
  data: function () {
    return {
      FullTopicFilters: null
    }
  },
  mounted: function () {
    if (TopicFilters == null) {
      TopicFilters = this.$parent.backupSettings.topic
    }

    this.FullTopicFilters = Object.keys(TopicFilters).map((el, index) => {
      return {
        shortname : el,
        name : TopicFilters[el],
        id : index,
        resultsCount: 0,
        kind: 'topics'
      }
    })

  }
};
</script>

<style scoped lang="scss">
.TopicOptions {

}
</style>
